import React, { useState, useRef } from 'react'
import { message, Modal, Form, Select } from 'antd'
import { Link } from 'react-router-dom'
import env from '@/env'
import { formateTimeStamp, copy } from '@/common/utils'
import ModalOutside from '@/components/modal'
import './index.less'
import App from './components/APP'
import Pc from './components/PC'
import Mini from './components/MINI'
import Copy from '@/components/copy'

const { Option } = Select

const CommonCard = (props) => {
  const [form] = Form.useForm()
  const timeout = useRef(null)
  const { item, toLookData, toLinkActivity } = props
  const [cardItem, setCardItem] = useState('')
  const [channel, setChannel] = useState('1')
  const [avenueLinkVisible, setAvenueLinkVisible] = useState(false)
  const cardStatusColor = [
    {
      key: '进行中',
      value: 'ING',
      id: '2'
    },
    {
      key: '未开始',
      value: 'WILL',
      id: '1'
    },
    {
      key: '已过期',
      value: 'ED',
      id: '3'
    },
    {
      key: '已下线',
      value: 'ED',
      id: '4'
    }
  ]

  function renderCardStatusColor (status) {
    for (let i = 0; i < cardStatusColor.length; i++) {
      if (cardStatusColor[i].id === status) {
        return `${cardStatusColor[i].value} status`
      }
    }
  }

  function renderStatus (status) {
    for (let i = 0; i < cardStatusColor.length; i++) {
      if (cardStatusColor[i].id === status) {
        return cardStatusColor[i].key
      }
    }
  }

  function showPop (item) {
    setAvenueLinkVisible(true)
    setCardItem(item)
  }

  function toProgramManage () {
    const BABEL_URL = env.BABEL_DOMAIN + '/active/babelCommon/index.html#/'
    window.open(BABEL_URL)
  }

  const channels = [
    {
      value: 'APP链接',
      id: '1'
    },
    {
      value: 'WQ链接',
      id: '2'
    },
    {
      value: 'PC链接',
      id: '3'
    },
    {
      value: '小程序链接',
      id: '4'
    }
  ]

  function handleChange (value) {
    if (value) setChannel(value)
  }

  function RenderChannel (item) {
    switch (channel) {
      case '1': return <App item={item} toCopy={toCopy} flag='APP' />
      case '2': return <App item={item} toCopy={toCopy} flag='WQ' />
      case '3': return <Pc item={item} toCopy={toCopy} />
      case '4': return <Mini item={item} toCopy={toCopy} />
      default: return <App item={item} toCopy={toCopy} flag='APP' />
    }
  }

  function toCopy (e, link) {
    e.preventDefault()
    const result = copy(link)
    if (result) {
      message.success('复制成功!')
      reset()
    } else {
      message.success('复制失败!')
      reset()
    }
  }

  function reset () {
    if (timeout.current) {
      clearTimeout(timeout.current)
    }
    timeout.current = setTimeout(() => {
    }, 1000)
  }

  return (
    <>
      <div className='card-item normal-flow' key={item.id}>
        <Link to={`/activity-manage/myCreate/avenue/detail?towerId=${item.id}`}>
          <div className='content'>
            <div className='title'>{item.name}</div>
            <div className='status-wrap'>
              <div className={renderCardStatusColor(item.status)}>{renderStatus(item.status)}</div>
              <div className={item.tag.related === 1 ? 'related-status YES' : 'related-status'}>{item.tag.related === 1 ? '  已关联' : '  未关联'}</div>
            </div>
            <div className='time-title'>
              <span className='item-title-lable'>通天塔项目ID：</span>
              <Copy className='startTime'>{item.id}</Copy>
            </div>
            <div className='time-title'>
              <span className='item-title-lable'>创建人：</span>
              <Copy className='startTime'>{item.createErp}</Copy>
            </div>
            <div className='time-title'>
              <span className='item-title-lable'>活动时间：</span>
              <span className='startTime'>{formateTimeStamp(item.startTime, true)}</span>
            </div>
            <div className='endTime'><span className='item-title-lable' />{formateTimeStamp(item.endTime, true)}</div>
          </div>
        </Link>
        <div className='btn'>
          <div className='top-level-btn'>
            <div
              className='leftBtn'
              onClick={() => showPop(item)}
            >
              会场链接
            </div>
            <div
              className='rightBtn'
              onClick={toProgramManage}
            >
              项目管理
            </div>
          </div>
          <div className='second-level-btn'>
            {
              item.btns.dataView === 1 ? (
                <div onClick={(e) => toLookData(e, item)} className='leftBtn' target='_blank' rel='noopener noreferrer'>查看数据</div>
              ) : (
                <span
                  className='leftBtn noPower'
                  onClick={() => {
                    message.warning('无权限，请联系活动创建人进行分享')
                  }}
                >查看数据
                </span>
              )
            }
            {
              item.btns.related === 1 ? (
                <div className='rightBtn' onClick={(e) => toLinkActivity(e, item.id)}>关联活动</div>
              ) : (
                <span
                  className='rightBtn noPower'
                  onClick={() => {
                    message.warning('无权限，请联系活动创建人进行分享')
                  }}
                >关联活动
                </span>
              )
            }
          </div>
        </div>
      </div>
      <ModalOutside>
        <Modal
          title='会场链接'
          visible={avenueLinkVisible}
          onCancel={() => { setAvenueLinkVisible(false) }}
          okText='确认'
          cancelText='取消'
          footer={null}
          width={529}
          className='avenue-link-pop'
        >
          <div className='avenue-link-title'>{cardItem.name}</div>
          <div className='avenue-link-form-wrap'>
            <Form form={form} labelAlign='right'>
              <Form.Item label='活动链接'>
                <Select defaultValue='1' style={{ width: 240 }} onChange={handleChange}>
                  {
                    channels.map(item => <Option key={item.id} value={item.id}>{item.value}</Option>)
                  }
                </Select>
              </Form.Item>
              {RenderChannel(cardItem)}
            </Form>
          </div>
        </Modal>
      </ModalOutside>
    </>
  )
}

export default CommonCard
